import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import About from "./pages/About";
import Dignitaries from "./pages/Dignitaries";
import Committee from "./pages/Committee";
import Call from "./pages/Call";
import Schedule from "./pages/Schedule";
import Registration from "./pages/Registration";
import Sponsorship from "./pages/Sponsorship";
import Speakers from "./pages/Speakers";
import Contact from "./pages/Contact";
import Gallery from "./pages/Gallery";
import "./App.css";
import ScrollToTop from "./components/ScrollToTop";
import Accommodation from "./pages/Accomodation";

function App() {
  return (
    <BrowserRouter>
      <div className="min-h-screen flex flex-col bg-white">
        <ScrollToTop />
        <Navbar />
        <main className="flex-1 pt-10">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/dignitaries" element={<Dignitaries />} />
            <Route path="/committee" element={<Committee />} />
            <Route path="/call/:type" element={<Call />} />
            <Route path="/schedule" element={<Schedule />} />
            <Route path="/registration" element={<Registration />} />
            <Route path="/sponsorship" element={<Sponsorship />} />
            <Route path="/speakers/:type" element={<Speakers />} />
            <Route path="/accommodation" element={<Accommodation />} />
            <Route
              path="/accomodation/:type?"
              element={<Navigate to="/accommodation" replace />}
            />
            <Route path="/contact" element={<Contact />} />
            <Route path="/gallery" element={<Gallery />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </BrowserRouter>
  );
}

export default App;
